import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Row, Col, Drawer } from "antd";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {
  PostTypeQuestionApi,
} from "api/getQuiz";
import {
  openNotificationWithIcon,
  validateMessages,
} from "../../../../Function";
import { QuestionCircleOutlined } from "@ant-design/icons";

const ModalCreateGroup = ({ open, onCancel, arrTypeQuestion }) => {
  const [form] = Form.useForm();
  const [inputTypeQs, setInputTypeQs] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  useEffect(() => {
    form.resetFields();
  }, [open]);

  const onFinish = (values) => {
    arrTypeQuestion.map((item) => {
      if (item.loai_cau_hoi == inputTypeQs || item.note == values.note) {
        openNotificationWithIcon(
          "error",
          "Trùng Tên nhóm đầy đủ/viết tắt trong hệ thống. Bạn vui lòng tạo lại."
        );
        return;
      }
    });

    PostTypeQuestionApi({
      loai_cau_hoi: values.loai_cau_hoi,
      note: values.note,
    })
      .then((res) => {

        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          openNotificationWithIcon("success", res.data.message);
          onCancel();
          form.resetFields();
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={
        <div
          style={{
            // display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Tạo nhóm</span>
          <Button
            type="link"
            icon={<QuestionCircleOutlined />}
            onClick={() => showDrawer()}
            style={{
              float: "right",
              marginRight: "25px",
              paddingBottom: "20px",
            }}
          ></Button>
        </div>
      }
      style={{ minWidth: "300px" }}
      width={500}
      footer={false}
      bodyStyle={{ paddingTop: 6 }}
      className={"site-drawer-render-in-current-wrapper"}
      maskClosable={false}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="Tên nhóm đầy đủ"
              name="note"
              rules={[{ required: true }]}
            >
              <Input maxLength={50} placeholder="Cơ bản" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="Tên nhóm viết tắt"
              name="loai_cau_hoi"
              rules={[
                { required: true, message: "Vui lòng nhập tên nhóm viết tắt" },
                {
                  pattern: /^[A-Z0-9@#&_-]+$/,
                  message:
                    "Chỉ cho phép chữ in hoa và ký tự: @, #, &, -, _",
                },
              ]}
            >
              <Input
                maxLength={15}
                placeholder="CB, ODC-DEV, CM_DRI-O, CM_T&S, ..."
                value={inputTypeQs}
                onChange={(e) => {
                  // const raw = e.target.value.toUpperCase();
                  // const filtered = raw.replace(/[^A-Z@#_-]/g, "");
                  setInputTypeQs(e.target.value);
                }}
                // style={{ textTransform: "uppercase" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
          <Button type="success" htmlType="submit" className={"m-2"}>
            Tạo
          </Button>
          <Button onClick={onCancel}>Thoát</Button>
        </Form.Item>
      </Form>
      <Drawer
        title="Hướng dẫn sử dụng"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={400}
        keyboard
        getContainer={false}
      >
        <p>
          <strong>1. Tên nhóm đầy đủ</strong>
        </p>
         <ul>
          <li>
            Tối đa 50 ký tự.
          </li>
           <li>
            Dùng để hiển thị và định nghĩa nhóm đề thi trên web.
          </li>
        </ul>
        <p>
          <strong>2. Tên nhóm viết tắt</strong>
        </p>
        <ul>
          <li>
            Tối đa 15 ký tự. Chỉ cho phép số, chữ in hoa và ký tự: @, #, &, -, _
          </li>
          <li>Dùng để định nghĩa mã đợt thi trong hệ thống web. Ví dụ: CB, ODC-DEV, CM_DRI-O, CM_T&S</li>
        </ul>
      </Drawer>
    </Modal>
  );
};

export default ModalCreateGroup;
